<template>
  <div justify-center>
    <v-card outlined>
      <v-card-title class="text-break text-center">{{
        formTitle
      }}</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-container>
            <v-row>
              <v-text-field
                v-model="editedEstablecimiento.nombre"
                :rules="nombreRules"
                :counter="nombreLength"
                label="Nombre *"
                :autofocus="!$vuetify.breakpoint.mobile"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-autocomplete
                v-model="editedEstablecimiento.idZona"
                :items="listaZona"
                :rules="zonaRules"
                item-text="nombre"
                item-value="idZona"
                label="Zona *"
              >
                <template slot="no-data">
                  <v-list-item>
                    <v-list-item-title>
                      Ninguna zona disponible
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-row>
            <v-row class="mt-3">
              <v-card flat>
                <v-card-subtitle class="ml-0 pl-0">Elige el tipo de explotación de su establecimiento (debe
                  elegir por lo menos uno) *</v-card-subtitle>
                <v-card-text class="pl-4">
                  <v-row
                    align="center"
                    v-if="
                      listaGrupoExplotacion.listaAgro.length > 1 ||
                      listaGrupoExplotacion.listaAgro[0].tipo !== 0
                    "
                  >
                    <v-checkbox
                      v-model="categoriaExpAgro"
                      label="Agricultura"
                      :true-value="1"
                      :false-value="0"
                      :rules="categoriaExpRules"
                      class="mt-0 pt-0 pr-5"
                      :disabled="editedIndex > 0"
                    ></v-checkbox>
                    <v-autocomplete
                      v-if="
                        listaGrupoExplotacion.listaAgro.length > 1 ||
                        listaGrupoExplotacion.listaAgro[0].tipo === 1
                      "
                      :disabled="!categoriaExpAgro || editedIndex > 0"
                      :rules="agroTipoExpRules"
                      :items="listaGrupoExplotacion.listaAgro"
                      v-model="tipoGrupoExpAgro"
                      label="Grupo Explotación"
                      outlined
                      item-text="nombre"
                      item-value="idGrupoExplotacion"
                      hide-no-data
                      required
                      dense
                      :readonly="editedIndex > 0"
                    >
                    </v-autocomplete>
                  </v-row>
                  <v-row
                    align="center"
                    v-if="
                      listaGrupoExplotacion.listaGanaderia.length > 1 ||
                      listaGrupoExplotacion.listaGanaderia[0].tipo !== 0
                    "
                  >
                    <v-checkbox
                      v-model="categoriaExpGanaderia"
                      label="Ganadería"
                      :true-value="2"
                      :false-value="0"
                      :rules="categoriaExpRules"
                      class="mt-0 pt-0 pr-6"
                      :disabled="editedIndex > 0"
                    ></v-checkbox>
                    <v-autocomplete
                      v-if="
                        listaGrupoExplotacion.listaGanaderia.length > 1 ||
                        listaGrupoExplotacion.listaGanaderia[0].tipo === 1
                      "
                      :disabled="!categoriaExpGanaderia || editedIndex > 0"
                      :rules="ganaderiaTipoExpRules"
                      :items="listaGrupoExplotacion.listaGanaderia"
                      v-model="tipoGrupoExpGanaderia"
                      label="Grupo Explotación"
                      outlined
                      item-text="nombre"
                      item-value="idGrupoExplotacion"
                      hide-no-data
                      required
                      dense
                      :readonly="editedIndex > 0"
                    >
                    </v-autocomplete>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      class="px-0"
                    >
                      <v-select
                        v-if="getTemporadasPendientes.length > 1 && categoriaExpGanaderia && editedIndex < 0"
                        v-model="temporadaEstablecimiento"
                        label="Temporada de la exp. ganadera"
                        :items="getTemporadasPendientes"
                        item-text="nombre"
                        return-object
                        :rules="temporadaRule"
                        :disabled="editedIndex > 0"
                        outlined
                        dense
                        hint="Si también eligió la explotación agricola, la temporada de esta siempre será la temporada actual"
                      ></v-select>
                      <div v-else-if="getTemporadasPendientes.length === 1">
                        {{ getTemporadasPendientes[0].nombre }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
            <v-row
              v-if="esAdmin && editedIndex !== -1"
              class="mt-2"
            >
              <v-col class="px-0">
                <v-btn @click="changeGruposExplotacion = true">Cambiar grupo explotación</v-btn>
                <v-card
                  flat
                  v-if="changeGruposExplotacion"
                  class="mt-3"
                >
                  <v-card-subtitle class="ml-0 pl-0 mb-2">Cambiar grupo explotación Agro</v-card-subtitle>
                  <v-row
                    class="mx-auto"
                    v-if="
                      listaGrupoExplotacion.listaAgro.length > 1 ||
                      listaGrupoExplotacion.listaAgro[0].tipo !== 0
                    "
                  >
                    <v-autocomplete
                      v-if="
                        listaGrupoExplotacion.listaAgro.length > 1 ||
                        listaGrupoExplotacion.listaAgro[0].tipo === 1
                      "
                      :rules="agroTipoExpRules"
                      :items="listaGrupoExplotacion.listaAgro"
                      v-model="tipoGrupoExpAgro"
                      label="Grupo explotación actual"
                      outlined
                      item-text="nombre"
                      item-value="idGrupoExplotacion"
                      hide-no-data
                      required
                      dense
                      :readonly="true"
                    >
                    </v-autocomplete>
                    <v-icon class="px-3 pb-5">fa-arrow-right</v-icon>
                    <v-autocomplete
                      v-if="
                        getGruposAgriculturaCompleto.length > 1
                      "
                      :rules="agroTipoExpNextRules"
                      :items="getGruposAgriculturaCompleto"
                      v-model="tipoGrupoExpAgroNext"
                      label="Grupo explotación nuevo"
                      outlined
                      item-text="nombre"
                      item-value="idGrupoExplotacion"
                      hide-no-data
                      required
                      dense
                    >
                    </v-autocomplete>
                  </v-row>
                  <v-card-subtitle class="ml-0 pl-0 mb-2">Cambiar grupo explotación Ganadería</v-card-subtitle>
                  <v-row
                    class="mx-auto"
                    v-if="
                      listaGrupoExplotacion.listaGanaderia.length > 1 ||
                      listaGrupoExplotacion.listaGanaderia[0].tipo !== 0
                    "
                  >
                    <v-autocomplete
                      v-if="
                        listaGrupoExplotacion.listaGanaderia.length > 1 ||
                        listaGrupoExplotacion.listaGanaderia[0].tipo === 1
                      "
                      :rules="ganaderiaTipoExpRules"
                      :items="listaGrupoExplotacion.listaGanaderia"
                      v-model="tipoGrupoExpGanaderia"
                      label="Grupo explotación actual"
                      outlined
                      item-text="nombre"
                      item-value="idGrupoExplotacion"
                      hide-no-data
                      required
                      dense
                      :readonly="true"
                    >
                    </v-autocomplete>
                    <v-icon class="px-3 pb-5">fa-arrow-right</v-icon>
                    <v-autocomplete
                      v-if="
                        getGruposGanaderiaCompleto.length > 1
                      "
                      :rules="ganaderiaTipoExpNextRules"
                      :items="getGruposGanaderiaCompleto"
                      v-model="tipoGrupoExpGanaderiaNext"
                      label="Grupo explotación nuevo"
                      outlined
                      item-text="nombre"
                      item-value="idGrupoExplotacion"
                      hide-no-data
                      required
                      dense
                    >
                    </v-autocomplete>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click.stop="cancelar"
        > Cancelar </v-btn>
        <v-btn
          color="primary"
          text
          @click.stop="save"
        > Guardar </v-btn>
      </v-card-actions>
    </v-card>
    <FhConfirmDialog ref="confirmDialog"></FhConfirmDialog>
  </div>
</template>

<script>
import FhContainer from "@/components/FhContainer";
import { mapActions, mapGetters, mapState } from "vuex";
import ConfiguracionRepository from "@/services/ConfiguracionRepository";
import FhConfirmDialog from "../FhConfirmDialog.vue";

export default {
  name: "FhCrudEstablecimientos",
  components: { FhContainer, FhConfirmDialog },
  props: {
    formTitle: String,
    editData: Object,
  },
  watch: {
    editData() {
      if (this.editData) {
        this.editedEstablecimiento = Object.assign(
          {},
          this.editData.editedEstablecimiento
        );
        this.editedIndex = this.editedEstablecimiento.idEstablecimiento;
        this.categoriaExpGanaderia = this.editData.categoriaExpGanaderia;
        this.categoriaExpAgro = this.editData.categoriaExpAgro;
        this.tipoGrupoExpAgro = this.editData.tipoGrupoExpAgro;
        this.tipoGrupoExpGanaderia = this.editData.tipoGrupoExpGanaderia;
        this.establecimientoChange.nombre = this.editedEstablecimiento.nombre;
        this.establecimientoChange.idZona = this.editedEstablecimiento.idZona;
      } else {
        this.editedIndex = -1
      }
    },
    categoriaExpGanaderia(val, oldVal) {
      if (val !== oldVal) {
        if (!val) {
          this.tipoGrupoExpGanaderia = null;
        }
      }
    },
    categoriaExpAgro(val, oldVal) {
      if (val !== oldVal) {
        if (!val) {
          this.tipoGrupoExpAgro = null;
        }
      }
    },
  },
  data() {
    return {
      editedIndex: -1,
      editedEstablecimiento: {
        idEstablecimiento: 0,
        idAgricultor: 0,
        idZona: 0,
        nombre: "",
      },
      defaultEstablecimiento: {
        idEstablecimiento: 0,
        idAgricultor: 0,
        idZona: 0,
        nombre: "",
      },
      currentAgricultor: "",
      establecimientoChange: { nombre: "", idZona: 0 },
      // Form
      categoriaExpAgro: 0,
      categoriaExpGanaderia: 0,
      tipoGrupoExpAgro: null,
      tipoGrupoExpAgroNext: null,
      tipoGrupoExpGanaderia: null,
      tipoGrupoExpGanaderiaNext: null,
      idExplotacionGanadera: null,
      isSubmit: true,
      valid: false,
      changeGruposExplotacion: false,
      temporadaEstablecimiento: null,
      nombreLength: 50,
      zonaRules: [(v) => !this.isSubmit || !!v || "Campo obligatorio"],
      temporadaRule: [(v) => !this.isSubmit || !!v || "Campo obligatorio"],
      nombreRules: [
        (v) => !this.isSubmit || !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.nombreLength ||
          `No debe superar ${this.nombreLength} caracteres`,
      ],
      agroTipoExpRules: [
        (v) =>
          !this.isSubmit ||
          this.categoriaExpAgro === 0 ||
          !!v ||
          "Campo obligatorio",
      ],
      categoriaExpRules: [
        (v) =>
          !this.isSubmit ||
          this.categoriaExpAgro !== 0 ||
          this.categoriaExpGanaderia !== 0 ||
          "Debe elegir por lo menos un tipo de explotación",
      ],
      ganaderiaTipoExpRules: [
        (v) =>
          !this.isSubmit ||
          this.categoriaExpGanaderia === 0 ||
          !!v ||
          "Campo obligatorio",
      ],
      agroTipoExpNextRules: [
        (v) =>
          !this.isSubmit || this.tipoGrupoExpAgro === null ||
          this.tipoGrupoExpAgro !== this.tipoGrupoExpAgroNext ||
          "No puede elegir el grupo de explotación actual",
      ],
      ganaderiaTipoExpNextRules: [
        (v) =>
          !this.isSubmit || this.tipoGrupoExpGanaderia === null ||
          this.tipoGrupoExpGanaderiaNext !== this.tipoGrupoExpGanaderia ||
          "No puede elegir el grupo de explotación actual",
      ],
    };
  },
  computed: {
    ...mapState("session", ["isRestored"]),
    ...mapState("zonas", ["listaZona"]),
    ...mapState("agricultor", ["listaGrupoExplotacion", "agricultor"]),
    ...mapState("temporada", ["temporada", "listaTemporada"]),
    ...mapGetters("temporada", ["getTemporadasPendientes"]),
    ...mapState("admin", ["esAdmin"]),
    ...mapGetters("grupoExplotacion", ["getGruposGanaderiaCompleto", "getGruposAgriculturaCompleto"]),
  },
  methods: {
    ...mapActions("agricultor", ["fetchListaGrupoExplotacion"]),
    ...mapActions("snackbar", ["showSnackbar"]),
    ...mapActions("zonas", ["fetchListaZona"]),
    ...mapActions("grupoExplotacion", ["fetchListaGrupoExplotacionParameter"]),
    ...mapActions("establecimientos", [
      "clearEstablecimiento",
      "clearEstablecimientoList",
      "setEstablecimientoSimple",
    ]),
    ...mapActions("temporada", [
      "fetchListaTemporadaAgricultor",
      "fetchListaTemporada",
    ]),
    async save() {
      try {
        this.isSubmit = true;
        if (!this.$refs.form.validate()) {
          return;
        }
        if (this.editedIndex > -1) {
          if (
            this.establecimientoChange?.nombre !==
            this.editedEstablecimiento.nombre ||
            this.establecimientoChange?.idZona !==
            this.editedEstablecimiento.idZona
          ) {
            let idGrupo =
              this.tipoGrupoExpAgro !== null
                ? this.tipoGrupoExpAgro
                : this.tipoGrupoExpGanaderia;
            await ConfiguracionRepository.actualizarEstablecimiento(
              this.agricultor.idAgricultor,
              this.editedEstablecimiento.idEstablecimiento,
              this.editedEstablecimiento.idZona,
              this.editedEstablecimiento.nombre,
              idGrupo
            );
          } else if (
            this.tipoGrupoExpAgroNext !== null ||
            this.tipoGrupoExpGanaderiaNext !== null) {
            let temporada =
              this.temporadaEstablecimiento !== null
                ? this.temporadaEstablecimiento
                : this.temporada;

            if (this.tipoGrupoExpAgroNext !== null && this.tipoGrupoExpAgro !== this.tipoGrupoExpAgroNext) {
              const confirmed = await this.$refs.confirmDialog.show(
                'Cambiar grupo explotación',
                `¿Está seguro que quiere cambiar el grupo explotación agricultura de ${this.listaGrupoExplotacion.listaAgro.find((g) => g.idGrupoExplotacion === this.tipoGrupoExpAgro)?.nombre} a ${this.getGruposAgriculturaCompleto.find(g => g.idGrupoExplotacion === this.tipoGrupoExpAgroNext).nombre}?`
              )

              if (confirmed) {
                await ConfiguracionRepository.cambiarGrupoExplotacion(this.editedEstablecimiento.idEstablecimiento, this.tipoGrupoExpAgro, this.tipoGrupoExpAgroNext, temporada.idTemporada)
              }
            }
            if (this.tipoGrupoExpGanaderiaNext !== null && this.tipoGrupoExpGanaderia !== this.tipoGrupoExpGanaderiaNext) {
              const confirmed = await this.$refs.confirmDialog.show(
                'Cambiar grupo explotación',
                `¿Está seguro que quiere cambiar el grupo explotación ganadería de ${this.listaGrupoExplotacion.listaGanaderia.find((g) => g.idGrupoExplotacion === this.tipoGrupoExpGanaderia)?.nombre} a ${this.getGruposGanaderiaCompleto.find(g => g.idGrupoExplotacion === this.tipoGrupoExpGanaderiaNext).nombre}?`
              )

              if (confirmed) {
                await ConfiguracionRepository.cambiarGrupoExplotacion(this.editedEstablecimiento.idEstablecimiento, this.tipoGrupoExpGanaderia, this.tipoGrupoExpGanaderiaNext, temporada.idTemporada)
              }
            }
          } else {
            this.cancelar();
            this.isSubmit = false;
            return;
          }

        } else {
          let grupoExpList = [];
          if (this.tipoGrupoExpAgro !== null && this.tipoGrupoExpAgro !== 0) {
            grupoExpList.push(this.tipoGrupoExpAgro);
          } else if (
            (this.tipoGrupoExpAgro === null || this.tipoGrupoExpAgro === 0) &&
            this.categoriaExpAgro !== 0 &&
            this.listaGrupoExplotacion.listaAgro[0].tipo === 2
          ) {
            grupoExpList.push(
              this.listaGrupoExplotacion.listaAgro[0].idGrupoExplotacion
            );
          }
          if (
            this.tipoGrupoExpGanaderia !== null &&
            this.tipoGrupoExpGanaderia !== 0
          ) {
            grupoExpList.push(this.tipoGrupoExpGanaderia);
            this.idExplotacionGanadera = this.tipoGrupoExpGanaderia;
          } else if (
            (this.tipoGrupoExpGanaderia === null ||
              this.tipoGrupoExpGanaderia === 0) &&
            this.categoriaExpGanaderia !== 0 &&
            this.listaGrupoExplotacion.listaGanaderia[0].tipo === 2
          ) {
            grupoExpList.push(
              this.listaGrupoExplotacion.listaGanaderia[0].idGrupoExplotacion
            );
            this.idExplotacionGanadera =
              this.listaGrupoExplotacion.listaGanaderia[0].idGrupoExplotacion;
          }
          let created = null;
          if (
            this.agricultor.idAgricultor &&
            this.editedEstablecimiento.idZona &&
            grupoExpList.length !== 0 &&
            this.editedEstablecimiento.nombre
          ) {
            created = await ConfiguracionRepository.crearEstablecimiento(
              this.agricultor.idAgricultor,
              this.editedEstablecimiento.idZona,
              grupoExpList,
              this.editedEstablecimiento.nombre
            );
          } else {
            return;
          }

          await this.setEstablecimientoSimple(created);
          let temp =
            this.temporadaEstablecimiento !== null
              ? this.temporadaEstablecimiento
              : this.temporada;
          if (this.idExplotacionGanadera !== null && temp?.idTemporada) {
            await ConfiguracionRepository.crearFichaGanadera(
              created.idEstablecimiento,
              this.idExplotacionGanadera,
              temp.idTemporada
            );
            await ConfiguracionRepository.crearLoteAnimalPredeterminado(
              this.agricultor.idAgricultor,
              created.idEstablecimiento
            );
          }
        }
        this.clearEstablecimiento();
        await this.clearEstablecimientoList();

        this.cancelar();
        this.isSubmit = false;
      } catch (e) { }
    },
    cancelar() {
      this.$nextTick(() => {
        this.editedEstablecimiento = Object.assign(
          {},
          this.defaultEstablecimiento
        );
        this.editedIndex = -1;
        this.categoriaExpGanaderia = 0;
        this.categoriaExpAgro = 0;
        this.tipoGrupoExpAgro = null;
        this.tipoGrupoExpGanaderia = null;
        this.establecimientoChange = { nombre: "", idZona: 0 };
      });
      this.$emit("terminated");
    },
  },
  async created() {
    while (!this.isRestored) {
      await this.$sleep(10);
    }
    if (this.editData) {
      this.editedEstablecimiento = Object.assign(
        {},
        this.editData.editedEstablecimiento
      );
      this.editedIndex = this.editedEstablecimiento.idEstablecimiento;
      this.categoriaExpGanaderia = this.editData.categoriaExpGanaderia;
      this.categoriaExpAgro = this.editData.categoriaExpAgro;
      this.tipoGrupoExpAgro = this.editData.tipoGrupoExpAgro;
      this.tipoGrupoExpGanaderia = this.editData.tipoGrupoExpGanaderia;
      this.establecimientoChange.nombre = this.editedEstablecimiento.nombre;
      this.establecimientoChange.idZona = this.editedEstablecimiento.idZona;
    }
    await this.fetchListaGrupoExplotacion(this.agricultor.idAgricultor);
    await this.fetchListaZona();
    await this.fetchListaTemporada();
    this.fetchListaGrupoExplotacionParameter()

    if (
      this.listaGrupoExplotacion.listaAgro.length === 0 &&
      this.listaGrupoExplotacion.listaGanaderia.length === 0 &&
      this.listaGrupoExplotacion.listaParticular.length === 0
    ) {
      this.showSnackbar([
        "Usted no tiene permisos para administrar o agregar establecimientos de este agricultor",
      ]);
      return;
    }
  },
};
</script>